import React, { useState } from "react";
import "../assets/css/Contact.css";
import { motion } from "framer-motion";
import {
  FaEnvelope,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaLinkedin,
  FaGithub,
  FaLink,
  FaInstagram,
} from "react-icons/fa";

const Contact = () => {
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);

    const response = await fetch("https://formspree.io/f/xwpokgar", {
      method: "POST",
      body: data,
      headers: {
        Accept: "application/json",
      },
    });

    if (response.ok) {
      form.reset();
      setStatus("SUCCESS");
      setTimeout(() => setStatus(""), 5000); // Hide after 5 seconds
    } else {
      setStatus("ERROR");
    }
  };

  return (
    <section id="contact" className="contact-section">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="contact-wrapper"
      >
        {/* LEFT SIDE */}
        <div className="contact-left">
          <h2 className="contact-title">Let's Connect</h2>
          <p className="contact-sub">
            Feel free to reach out via any method below!
          </p>

          {/* Social Links Section */}
          <div className="contact-item contact-row">
            <FaLink className="contact-icon" />
            <div className="contact-text">
              <h4>Socials Links</h4>
              <div className="social-links-row">
                <a
                  href="https://www.instagram.com/tefzz__?igsh=dXllY25tZ3ppZTI0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram /> Instagram
                </a>
                <a
                  href="https://www.linkedin.com/in/tefeena/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin /> LinkedIn
                </a>
                <a
                  href="https://github.com/tefeena"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaGithub /> Github
                </a>
              </div>
            </div>
          </div>

          <div className="contact-item contact-row">
            <FaEnvelope className="contact-icon" />
            <div className="contact-text">
              <h4>Email</h4>
              <a href="mailto:tefeenajohn@gmail.com">tefeenajohn@gmail.com</a>
            </div>
          </div>

          <div className="contact-item contact-row">
            <FaPhoneAlt className="contact-icon" />
            <div className="contact-text">
              <h4>Phone</h4>
              <a href="tel:+13828851076">+1 382 885 1076</a>
            </div>  
          </div>

          <div className="contact-item contact-row">
            <FaMapMarkerAlt className="contact-icon" />
            <div className="contact-text">
              <h4>Location</h4>
              <p>Kitchener, Ontario, Canada</p>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="contact-right">
          <h3 className="form-title">Send me an Email</h3>
          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              required
              minLength={2}
              maxLength={50}
            />
            <input
              type="email"
              name="email"
              placeholder="example@email.com"
              required
              pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
              title="Please enter a valid email address"
            />
            <textarea
              name="message"
              rows="5"
              placeholder="Write your message here..."
              required
              minLength={10}
            ></textarea>
            <button type="submit" className="send-button">
              Send Email
            </button>

            {status === "SUCCESS" && (
              <p className="text-green-400 mt-4 font-medium">
                ✅ Your message has been successfully sent to Tefeena!
              </p>
            )}
            {status === "ERROR" && (
              <p className="text-red-400 mt-4 font-medium">
                ❌ Oops! Something went wrong. Please try again.
              </p>
            )}
          </form>
        </div>
      </motion.div>
    </section>
  );
};

export default Contact;
